export const zhHK = {
  multiFactorAuth: "多重驗證",
  enterOTP: "請輸入從手機或電子郵件取得的一次性密碼",
  enterEmailOTP: "請輸入從電子郵件取得的一次性密碼",
  enterSMSOTP: "請輸入從手機取得的一次性密碼",
  otp: "一次性密碼（OTP）",
  resendOTPEmail: "透過電子郵件重新發送一次性密碼",
  resendOTPSMS: "透過手機重新發送一次性密碼",
  rememberDevice: "記住此裝置",
  submit: "送出",
  cancel: "取消",
  second:"秒"
};
